<mat-toolbar [ngClass]="{'small-bar': smallbar}">
  <span>{{title}}</span>
  <span class="toolbar-spacer"></span>
  @if (showNewBtn) {
    <button type="button" mat-raised-button color="primary" routerLink="new">
      <span translate>{{newBtnTitle}}</span>
    </button>
  }
</mat-toolbar>
<div class="container-fluid">
  <div class="row mt-3">
    <div class="col-md-12">
      <mat-form-field class="w-100">
        <mat-label translate>SEARCH</mat-label>
        <input type="text" matInput [(ngModel)]="searchText" (keyup)="applyFilter()">
        @if (searchText) {
          <button mat-icon-button color="primary" matSuffix (click)="$event.stopPropagation();searchText = '';applyFilter();"><mat-icon>close</mat-icon></button>
        }
      </mat-form-field>
    </div>
  </div>
</div>
<table mat-table [dataSource]="dataSource" matSort class="w-100">

  @for (col of columns; track col) {
    <ng-container matColumnDef="{{col.id}}">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="col.sortDisabled"> {{col.label}} </th>
      <td mat-cell *matCellDef="let element">
        @switch (col.type) {
          @case (1) {
            <div [ngClass]="col.colClass">{{element[col.id]}}</div>
          }
          @case (2) {
            <div><img class="table-image" [src]="element[col.id]"></div>
          }
          @case (3) {
            <div>
              @for (item of element[col.id]; track item) {
                <span class="badge text-bg-secondary ms-1">{{item.name ? item.name : '-'}}</span>
              }
            </div>
          }
          @case (4) {
            <div [ngClass]="col.colClass">{{element[col.id] ? element[col.id].name : ''}}</div>
          }
          @case (5) {
            <div> <mat-icon>{{element[col.id] ? 'check_box' : 'check_box_outline_blank'}}</mat-icon></div>
          }
          @case (6) {
            <div>
              <button type="button" mat-icon-button routerLink="{{element.id}}" color="primary"><mat-icon>{{col.label}}</mat-icon></button>
            </div>
          }
        }
      </td>
    </ng-container>
  }


  <tr mat-header-row *matHeaderRowDef="allColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: allColumns;"></tr>
</table>
@if (items.length === 0) {
  <div class="d-block text-center bg-white p-3">Nincs adat</div>
}
<mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
